import {
  useMessageContext,
  useModalContext,
  useTasksContext,
} from "../../../providers";

import { tasksFetcher } from "../../../services/api";

import { Task } from "../../../types/task";

import PopupModal from "../PopupModal";

const ReactivateTask = () => {
  const { modalOpen, closeModal, taskSelected } = useModalContext();

  const { sendMessage } = useMessageContext();
  const { updateTask } = useTasksContext();

  const onReactivateTask = async () => {
    try {
      const taskUndeleted = await tasksFetcher.reactivateTask(
        (taskSelected as Task).id
      );
      sendMessage(
        `El document "${taskSelected?.name}" ha sigut reactivat correctament`,
        "success"
      );
      updateTask({ ...taskUndeleted, deleted_at: null });
      closeModal();
    } catch (error) {
      console.error(error);
      sendMessage(
        `Alguna cosa ha anat malament reactivant el document: "${taskSelected?.name}". Si us plau, torna a intentar-ho en uns moments`,
        "error",
        3
      );
    }
  };

  return (
    <PopupModal
      open={modalOpen === "reactivateTask"}
      onConfirm={onReactivateTask}
      onCancel={closeModal}
      confirmText="Processar"
    >
      <h3 className="lg normal">Tornar a processar el document</h3>
      <p>Pots intentar tornar a processar el document.</p>
      <p>Si continua fallant, si us plau, contacta amb support.</p>
    </PopupModal>
  );
};
export default ReactivateTask;
